export const GET_MOVIES = "GET_MOVIES";
export const GET_MOVIE = "GET_MOVIE";
export const GET_GENRES = "GET_GENRES";
export const FETCHING = "FETCHING";
export const FETCHED = "FETCHED";
